{
  "success": "{{key}} exitosamente!",
  "error": "Error {{verb}} un {{noun}}!",
  "there-is-an": "hubo un error, intentelo de nuevo.",
  "order-created": "la orden fue creada,",
  "order-updated": "Orden actualizada",
  "order-updating": "Actualizando información de la orden..."
}
